import { render } from "./CreateFormByLib_Goals.vue?vue&type=template&id=1b4ba575&scoped=true"
import script from "./CreateFormByLib_Goals.vue?vue&type=script&lang=js"
export * from "./CreateFormByLib_Goals.vue?vue&type=script&lang=js"

import "./CreateFormByLib_Goals.vue?vue&type=style&index=0&id=1b4ba575&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4ba575"]])

export default __exports__